import { ChangeEvent, Fragment } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";

import { NodeEnv } from "@dzambalaorg/constants";
import { PageHeader } from "@dzambalaorg/mui-page-layout";
import { Tabs } from "@dzambalaorg/ui-kit";
import { ProfileAddresses } from "@framework/shared";

import { ProfileGeneral } from "./general";
import { ProfileSubscriptions } from "./subscriptions";
import { ProfileTabs } from "./interfaces";

export const Profile = () => {
  const { tab = ProfileTabs.general } = useParams<{ tab: ProfileTabs }>();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleChange = (_event: ChangeEvent<any>, newValue: ProfileTabs): void => {
    void navigate(`/profile/${newValue === ProfileTabs.general ? "" : newValue}`);
  };

  const shouldHideAddress = process.env.NODE_ENV === NodeEnv.production;

  return (
    <Fragment>
      <PageHeader message="pages.profile.title" />

      <Tabs
        sx={theme => ({ marginBottom: theme.spacing(theme.tokens.spacing["3xl"]) })}
        value={tab}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {Object.values(ProfileTabs).map(tab =>
          shouldHideAddress && tab === ProfileTabs.addresses ? null : (
            <Tabs.Tab key={tab} label={formatMessage({ id: `pages.profile.tabs.${tab}` })} value={tab} />
          ),
        )}
      </Tabs>
      <ProfileGeneral open={tab === ProfileTabs.general} />
      {!shouldHideAddress ? <ProfileAddresses open={tab === ProfileTabs.addresses} /> : null}
      <ProfileSubscriptions open={tab === ProfileTabs.subscriptions} />
    </Fragment>
  );
};
